import React from 'react'
import { createPortal } from 'react-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Tray } from '@mobi/component-library/Overlays/Tray'
import { Icon } from '@mobi/component-library/Common/V2'
import { colors } from '@mobi/component-library/Theme/Common'
import { setBonusDescriptionToDisplay } from '@core/Areas/AppHeader/Store'
import { getBonusDescriptionToDisplay } from '@core/Areas/AppHeader/Store/selectors'
import { TrayArticleStyled } from './common.styles'

export const BonusBetDescriptionTooltipTray: React.FC = () => {
  const dispatch = useDispatch()
  const showBonusDescription = useSelector(getBonusDescriptionToDisplay)

  return createPortal(
    <Tray
      isOpen={showBonusDescription === 'bonus_bet'}
      headerTitle='Bonus Bets'
      dismissStatus='allowed'
      onDismiss={() => dispatch(setBonusDescriptionToDisplay(undefined))}
    >
      <TrayArticleStyled>
        <section>
          <Icon name='DuocolorCurrencyDollarCircle' color={colors.success[600]} size='5rem' />
        </section>

        <div />

        <p>
          Bonus Bets are a great way to get some extra chances to land a winner—on us! You can use
          Bonus Bets to bet on <b>Racing</b>, giving you the thrill of betting without touching your
          cash balance.
        </p>

        <p>
          When you’re placing a racing bet, you’ll have the option to apply your Bonus Bet—just
          select it on the bet slip or when using <b>QuickBet</b>. You’re in control and can choose
          when to use them. Plus, Bonus Bets are flexible, meaning you can split them into smaller
          amounts if you’d rather place a few bets instead of one big one.
        </p>

        <p>
          If your bet wins, you’ll collect the winnings—without the Bonus Bet stake. That means you
          walk away with the profit from the bet, ready to use however you like.
        </p>

        <p>
          Your <b>Bonus Bets balance</b> is easy to find—just check your <b>account menu</b>, where
          it’s clearly displayed and ready when you are.
        </p>

        <p>
          Bonus Bets are a simple, fun way to keep the action going and give yourself more chances
          to win!
        </p>
      </TrayArticleStyled>
    </Tray>,
    document.body
  )
}
